import auth from '@/auth/index'
let routes = [
  {
    path: '',
    component: resolve => require(['@/views/layout/Layout'], resolve),
    meta: {
      title: '隐私计算',
      breadLevel: 0,
      icon: 'icon-spv-light-nodes'
    },
    children: [
      {
        path: '/homomorphic-encryption',
        name: 'homomorphicEncryption',
        component: resolve => require(['@/views/privacyComputing/homomorphic.vue'], resolve),
        meta: {
          title: '同态加密',
          breadLevel: 0
        }
      },
      {
        path: '/homomorphic-encryption/taskDetail',
        name: 'hTaskDetail',
        component: resolve => require(['@/views/privacyComputing/homomorphicDetail.vue'], resolve),
        meta: {
          title: '任务详情',
          breadLevel: 1
        }
      },
      {
        path: '/zero-knowedge',
        name: 'zeroKnowedge',
        component: resolve => require(['@/views/privacyComputing/zeroKnowedge.vue'], resolve),
        meta: {
          title: '零知识证明',
          breadLevel: 0
        }
      },
      {
        path: '/zero-knowedge/taskDetail',
        name: 'knowedgeTaskDetail',
        component: resolve => require(['@/views/privacyComputing/zeroKnowedgeDetail.vue'], resolve),
        meta: {
          title: '任务详情',
          breadLevel: 1
        }
      },
      {
        path: '/more-demo',
        name: 'moreDemo',
        component: {
          render(c) {
            return c('router-view')
          }
        },
        meta: {
          title: '更多功能demo',
          breadLevel: 0
        },
        redirect: '/more-demo/more-homomorphic',
        children: [
          {
            path: '/more-demo/more-homomorphic',
            name: 'moreHomomorphic',
            component: resolve =>
              require(['@/views/privacyComputing/more/moreHomomorphic.vue'], resolve),
            meta: {
              title: '同态加密',
              breadLevel: 0
            }
          },
          {
            path: '/more-demo/more-knowedge',
            name: 'moreKnowedge',
            component: resolve =>
              require(['@/views/privacyComputing/more/moreKnowedge.vue'], resolve),
            meta: {
              title: '零知识证明',
              breadLevel: 0
            }
          }
        ]
      }
    ]
  }
]

export default routes
